import { BROADSIDER_OG_CONTRACT_ADDRESS } from '../constants';

const SIGNER_SERVICE_ADDRESS = 'https://signer.mksrv.xyz';

const getPass = async (tokenIds) => {
  const response = await fetch(
    `${SIGNER_SERVICE_ADDRESS}/owner/ethereum/${BROADSIDER_OG_CONTRACT_ADDRESS}/${tokenIds.join(',')}`
  );
  if (!response.ok) {
    throw new Error(`Cannot obtain mint pass for token ids ${tokenIds.join(',')}`);
  }
  const passes = await response.json();
  return passes.map((p) => ({ encoded: p.encoded, signature: p.signature }));
};

export const getOgPassesForTokens = async (tokenIds = []) => {
  if (tokenIds.length < 1) {
    return [];
  }
  const passes = await getPass(tokenIds);
  return passes;
};
